/**
 * Include your custom JavaScript here.
 *
 * We also offer some hooks so you can plug your own logic. For instance, if you want to be notified when the variant
 * changes on product page, you can attach a listener to the document:
 *
 * document.addEventListener('variant:changed', function(event) {
 *   var variant = event.detail.variant; // Gives you access to the whole variant details
 * });
 *
 * You can also add a listener whenever a product is added to the cart:
 *
 * document.addEventListener('product:added', function(event) {
 *   var variant = event.detail.variant; // Get the variant that was added
 *   var quantity = event.detail.quantity; // Get the quantity that was added
 * });
 *
 * If you just want to force refresh the mini-cart without adding a specific product, you can trigger the event
 * "cart:refresh" in a similar way (in that case, passing the quantity is not necessary):
 *
 * document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
 *   bubbles: true
 * }));
 */

// $(document).ready(function(){
//   $(document).on('click','.product-form__submit', function(e){
//     e.preventDefault();
//     // document.dispatchEvent(new CustomEvent("theme:loading:start"));
//     var variantId = $(this).attr("data-variant-id");
//     if(!$(this).hasClass('disabled')){
//       addItemToCart(variantId, 1);  
//     }
//     // console.log(variantId);

//     document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
//       bubbles: true,
//       detail: {
//         variant: variantId
//       }
//       //this code is for prestige theme, is to refresh the cart
//     }));

//   });
// });
// function addItemToCart(variantId, qty) {
//   data = {
//     "id": variantId,
//     "quantity": qty
//   }
//   jQuery.ajax({
//     type: 'POST',
//     url: '/cart/add.js',
//     data: data,
//     dataType: 'json',
//     success: function() {
//       // GLOBAL_CART._onCollectionAdded();
//       // document.dispatchEvent(new CustomEvent("theme:loading:end"));
//       document.dispatchEvent(new CustomEvent('product:added', {
//         bubbles: true,
//         detail: {
//           variant: variantId
//         }
//       }));
//     }     
//   }); 
// }


$(".Search__Close").click(function(){
	$(".Search__Input").val("");
  	$(".Search__Results").attr("aria-hidden", true);
     $(".Search__Close").hide();
       
});

$(document).mouseup(function(e) 
{
    var container = $(".Search__Inner");

    // if the target of the click isn't the container nor a descendant of the container
    if (!container.is(e.target) && container.has(e.target).length === 0) 
    {
      if($(".Search__Results").attr("aria-hidden") == "false"){
        $(".Search__Results").attr("aria-hidden", true);
       
      }
    }
});

function form_submit(form_id)
{
    let form = document.getElementById(form_id);
    if ( form )
    {
        form.submit();
    }
}

function button_click(buttom_id)
{
    let button = document.getElementById(buttom_id);
    if ( button )
    {
        button.click();
    }
}
